import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = {
  key: 0,
  class: "q-mt-sm q-pa-sm",
  style: {"background":"#f5f5f5","border-radius":"4px","font-size":"12px","line-height":"1.4"}
}
const _hoisted_3 = { class: "text-grey-7" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = {
  key: 0,
  class: "q-mt-sm q-pa-sm",
  style: {"background":"#f5f5f5","border-radius":"4px","font-size":"12px","line-height":"1.4"}
}
const _hoisted_6 = { class: "column" }
const _hoisted_7 = {
  class: "column",
  style: {"max-height":"300px","overflow-y":"auto"}
}
const _hoisted_8 = { class: "col q-pb-sm" }
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = { class: "text-right" }
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "text-right" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "text-right" }
const _hoisted_21 = { class: "text-h6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_popup_proxy = _resolveComponent("q-popup-proxy")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_markup_table = _resolveComponent("q-markup-table")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1 vertical-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand" }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("Broadcast Commands", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: _ctx.onBroadcastCommandsCloseClick
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Select Agms",
                dense: "",
                "no-caps": "",
                onClick: _ctx.onSelectDevicesButtonClick
              }, null, 8, ["onClick"]),
              (_ctx.selectedDevices.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, "AGMs (" + _toDisplayString(_ctx.selectedDevices.length) + "):", 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.truncatedSelectedDeviceLabels) + " ", 1),
                    (_ctx.selectedDevices.length > 5)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          style: {"font-size":"11px"},
                          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showAllAgmsSummary = !_ctx.showAllAgmsSummary), ["prevent"]))
                        }, _toDisplayString(_ctx.showAllAgmsSummary ? 'Show less' : 'Show all'), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Select Commands",
                dense: "",
                "no-caps": "",
                onClick: _ctx.onSelectCommandsButtonClick
              }, null, 8, ["onClick"]),
              (_ctx.selectedCommandLabels.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-grey-7" }, "Commands:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedCommandLabels.join(', ')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_q_btn, {
                class: "btn-brand",
                label: "Send Commands Now",
                dense: "",
                "no-caps": "",
                disable: 
              _ctx.selectedDevices.length === 0 || _ctx.selectedCommandLabels.length === 0
            ,
                onClick: _ctx.onSendCommandsNowButtonClick
              }, null, 8, ["disable", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showSelectDevicesDialog,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showSelectDevicesDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px","max-width":"90vm"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("Select Devices", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_q_option_group, {
                      modelValue: _ctx.selectedDevices,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDevices) = $event)),
                      dense: "",
                      options: _ctx.allDeviceOptions,
                      color: "indigo-9",
                      type: "checkbox"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Save",
                      type: "button",
                      "no-caps": "",
                      onClick: _ctx.onSelectDevicesDialogSaveButtonClick
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showSelectCommandsDialog,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showSelectCommandsDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"600px","max-width":"90vm"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode("Select Commands", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_markup_table, null, {
                  default: _withCtx(() => [
                    _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "text-left" }, [
                          _createElementVNode("span", { class: "text-bold" }, "Command")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _cache[23] || (_cache[23] = _createElementVNode("td", { class: "text-left" }, "Power mode (active)", -1)),
                        _createElementVNode("td", _hoisted_9, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandPowerMode,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.broadcastCommandPowerMode) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[24] || (_cache[24] = _createElementVNode("td", { class: "text-left" }, "Power mode (low power)", -1)),
                        _createElementVNode("td", _hoisted_10, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandPowerModeLowPower,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.broadcastCommandPowerModeLowPower) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[25] || (_cache[25] = _createElementVNode("td", { class: "text-left" }, "Settings - mag only", -1)),
                        _createElementVNode("td", _hoisted_11, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandFrequencySettingsMagOnly,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.broadcastCommandFrequencySettingsMagOnly) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("td", { class: "text-left" }, "Settings - mag + 22 Hz", -1)),
                        _createElementVNode("td", _hoisted_12, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandFrequencySettingsElfMag,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.broadcastCommandFrequencySettingsElfMag) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[27] || (_cache[27] = _createElementVNode("td", { class: "text-left" }, "Settings - 22 Hz Only", -1)),
                        _createElementVNode("td", _hoisted_13, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandFrequencySettingsElfOnly,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.broadcastCommandFrequencySettingsElfOnly) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[28] || (_cache[28] = _createElementVNode("td", { class: "text-left" }, "Settings - all detectors off", -1)),
                        _createElementVNode("td", _hoisted_14, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandFrequencySettingsAllDetectorsOff,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.broadcastCommandFrequencySettingsAllDetectorsOff) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[29] || (_cache[29] = _createElementVNode("td", { class: "text-left" }, "Format disk", -1)),
                        _createElementVNode("td", _hoisted_15, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandFormatDisk,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.broadcastCommandFormatDisk) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[30] || (_cache[30] = _createElementVNode("td", { class: "text-left" }, "Download between dates", -1)),
                        _createElementVNode("td", _hoisted_16, [
                          _createVNode(_component_q_checkbox, {
                            modelValue: _ctx.broadcastCommandRequestForDownload,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.broadcastCommandRequestForDownload) = $event)),
                            color: "blue-brand"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      (_ctx.broadcastCommandRequestForDownload)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                            _cache[31] || (_cache[31] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", _hoisted_18, [
                              _createVNode(_component_q_input, {
                                modelValue: _ctx.broadcastCommandRequestForDownloadStartDate,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.broadcastCommandRequestForDownloadStartDate) = $event)),
                                dense: "",
                                filled: "",
                                label: "Start Date (UTC)"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "event",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref: "qStartDateProxy",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_date, {
                                            modelValue: 
                              _ctx.broadcastCommandRequestForDownloadStartDate
                            ,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((
                              _ctx.broadcastCommandRequestForDownloadStartDate
                            ) = $event)),
                                            mask: "YYYY-MM-DD HH:mm:ss",
                                            onInput: _ctx.hideStartDateProxy
                                          }, null, 8, ["modelValue", "onInput"])
                                        ]),
                                        _: 1
                                      }, 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "access_time",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref: "qStartTimeProxy",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_time, {
                                            modelValue: 
                              _ctx.broadcastCommandRequestForDownloadStartDate
                            ,
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                              _ctx.broadcastCommandRequestForDownloadStartDate
                            ) = $event)),
                                            mask: "YYYY-MM-DD HH:mm:ss",
                                            format24h: "",
                                            onInput: _ctx.hideStartTimeProxy
                                          }, null, 8, ["modelValue", "onInput"])
                                        ]),
                                        _: 1
                                      }, 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.broadcastCommandRequestForDownload)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                            _cache[32] || (_cache[32] = _createElementVNode("td", null, null, -1)),
                            _createElementVNode("td", _hoisted_20, [
                              _createVNode(_component_q_input, {
                                modelValue: _ctx.broadcastCommandRequestForDownloadEndDate,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.broadcastCommandRequestForDownloadEndDate) = $event)),
                                dense: "",
                                filled: "",
                                label: "End Date (UTC)"
                              }, {
                                prepend: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "event",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref: "qEndDateProxy",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_date, {
                                            modelValue: _ctx.broadcastCommandRequestForDownloadEndDate,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.broadcastCommandRequestForDownloadEndDate) = $event)),
                                            mask: "YYYY-MM-DD HH:mm:ss",
                                            onInput: _ctx.hideEndDateProxy
                                          }, null, 8, ["modelValue", "onInput"])
                                        ]),
                                        _: 1
                                      }, 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                append: _withCtx(() => [
                                  _createVNode(_component_q_icon, {
                                    name: "access_time",
                                    class: "cursor-pointer"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_popup_proxy, {
                                        ref: "qEndTimeProxy",
                                        "transition-show": "scale",
                                        "transition-hide": "scale"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_time, {
                                            modelValue: _ctx.broadcastCommandRequestForDownloadEndDate,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.broadcastCommandRequestForDownloadEndDate) = $event)),
                                            mask: "YYYY-MM-DD HH:mm:ss",
                                            format24h: "",
                                            onInput: _ctx.hideEndTimeProxy
                                          }, null, 8, ["modelValue", "onInput"])
                                        ]),
                                        _: 1
                                      }, 512)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  class: "btn-brand",
                  label: "Save",
                  "no-caps": "",
                  onClick: _ctx.onSelectCommandsDialogSaveButtonClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showValidationMessageDialog,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showValidationMessageDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.validationDialogTitle), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.validationDialogMessage), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "OK",
                  color: "primary"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 512)), [
    [_vShow, _ctx.showBroadcastCommands]
  ])
}